import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE} from '../../../../store/search';
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUserDetails} from '../../../../models/user';
import {BM_EDIT_CONTRACTOR_BY_FIELD, BM_MODULE_NAMESPACE} from "../../../../store/building-monitor/bm-types.store";
import {BMContractorEditedViewModel} from "../../../../models/bm/bm-contractor-edited.viewmodel";
import {Moment} from "moment";
import * as moment from "moment";
import {IBMMeetingDetailViewModel} from "../../../../models/bm/bm-meeting-detail.viewmodel";

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
  }
})
class BMContractorModalVertical extends Vue {

  private dtStep: number;

  dtRules: {
    contractorRules?: any
  }
  dtSearchAllContact: boolean
  dtTemporaryContractors: any[];
  dtContractor: any
  dtLoadingContractor: boolean
  pmContractor: {
    entity: SearchEntities,
    query: string,
    limit: number,
    block: number[]
  }
  sendStartBM: boolean
  sendEndBM: boolean

  constructor() {
    super();
    this.dtRules = {};
    this.dtSearchAllContact = false
    this.dtTemporaryContractors = []
    this.dtContractor = null
    this.dtLoadingContractor = false
    this.dtStep = 15
    this.pmContractor = {
      entity: SearchEntities.Contractor,
      query: '',
      limit: 1000,
      block: []
    }
    this.sendStartBM = false
    this.sendEndBM = false
  }

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isTenantAndOwner: boolean;
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmContractorEdited: BMContractorEditedViewModel
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus, data: IBMMeetingDetailViewModel };

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { query }) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @BMStore.Mutation(BM_EDIT_CONTRACTOR_BY_FIELD)
  storeSetBMContractorEdited: (payload: { [key: string]: any }) => void

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean
  @Prop({ default: null, type: [Object] })
  sourceContractor: any

  get coDatesStart() {
    return {
      startDate: this.bmContractorEdited.date_start_work,
    }
  }
  set coDatesStart(dates: { startDate: string | Date | Moment }) {
    this.storeSetBMContractorEdited({
      date_start_work: dates.startDate.toString(),
    })
  }

  get coDatesEnd() {
    return {
      startDate: this.bmContractorEdited.date_end_work,
    }
  }
  set coDatesEnd(dates: { startDate: string | Date | Moment }) {
    this.storeSetBMContractorEdited({
      date_end_work: dates.startDate.toString(),
    })
  }

  get coProgress(): number {
    if (this.bmContractorEdited.progress) {
      return parseInt(this.bmContractorEdited.progress.replace('%', ''), 10)
    }
    return 0
  }

  set coProgress(value) {
    this.storeSetBMContractorEdited({
      progress: value+'%',
    })
  }

  get coContractors() {
    return (this.dtTemporaryContractors || []).filter(x => !!x)
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get dtSearchAll(): boolean {
    return this.dtSearchAllContact || false
  }

  set dtSearchAll(value: boolean) {
    this.dtSearchAllContact = value
  }

  get Contractor(): number {
    return this.bmContractorEdited.fk_entity_contractor
  }

  set Contractor(value) {
    this.storeSetBMContractorEdited({fk_entity_contractor: value})
  }

  created() {
    this.dtRules = {
      contractorRules: [(v) => !!v || this.$t(this.lblSetting.bmContractorRequired)]
    }
  }

  mounted() {
    this.$nextTick(() => {
      if (this.toUpdate) {
        delete this.pmContractor.entity
      } else {
        this.pmContractor.entity = SearchEntities.Contractor
      }
      this.changeSwitchSearch(this.toUpdate)
      if (this.toUpdate) {
        if (this.sourceContractor.date_start_work) {
          this.sendStartBM = true
        }
        if (this.sourceContractor.date_end_work) {
          this.sendEndBM = true
        }
      }
    })
  }

  changeSwitchSearch (value: boolean) {
    if (value)
      delete this.pmContractor.block
    else
      this.pmContractor.block = [this.bmMeeting.data.master.fk_block]
    this.getContractor()
  }

  changeSwitchStartDate (val) {
    if (val) {
      if (this.toUpdate) {
        this.coDatesStart = { startDate: this.sourceContractor.date_start_work || moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      } else {
        this.coDatesStart = { startDate: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      }
    } else {
      this.coDatesStart = { startDate: '' }
    }
  }

  changeSwitchEndDate (val) {
    if (val) {
      if (this.toUpdate) {
        this.coDatesEnd = { startDate: this.sourceContractor.date_end_work || moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      } else {
        this.coDatesEnd = { startDate: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14)+'00:00.000Z' }
      }
    } else {
      this.coDatesEnd = { startDate: '' }
    }
  }

  async getContractor(query: string = '') {
    this.pmContractor.query = query
    this.dtLoadingContractor = true
    return this.storeGetEntitySearch(this.pmContractor)
      .then(res => {
        this.dtTemporaryContractors = res
      })
      .finally(() => {
        this.dtLoadingContractor = false
      })
  }

  handleGetDeclarants(query: string) {
    return this.getContractor(query)
  }
  handleChangeContractor() {}
}

export default BMContractorModalVertical;



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-contractor-modal-vertical/index.ts